import { Injectable, Injector } from '@angular/core';
// import { ActivatedRoute } from '@angular/router';

@Injectable()
export class SocketSidekickService {

	public socketParamName = 'socketParam';
	public socketParam;
	public socket: WebSocket;
	constructor(
		// private injector: Injector
	) { }
	checkSocketParam() {
		const hash = window.location.hash ? decodeURIComponent(window.location.hash): '';
		// Reference: https://developers.arcgis.com/documentation/core-concepts/security-and-authentication/browser-based-user-logins/#using-the-arcgis-api-for-javascript
		const splits = hash.split('#');
		splits.find(s => {
			const reg = this.socketParamName + '=([^&]+)';
			const matchParam = s.match(new RegExp(reg));
			if (matchParam && matchParam[1]) {
				this.socketParam = matchParam[1];
				return true;
			}
		});
		// const socketParam = this.injector.get(ActivatedRoute) //.snapshot.paramMap.get(this.socketParamName);
		// if (socketParam) {
		// 	console.log('start sockettttttttttttttttttt');
		// } else {
		// 	console.log('noooooooooooooo')
		// }
	}
	sendMessage(msg: string) {
		if (this.socket) {
			this.socket.send(msg);
		}
	}
	async connect() {
		let socket = new WebSocket("ws://localhost:9000/");
		socket.onopen = function () { console.log("success"); };
		socket.onmessage = function (msg) { console.log(msg.data); };
		socket.onclose = function () { console.log("closed"); };
		this.socket = socket;
	};
	disconnectSocket() {
		this.socket.close();
	}
	onInitMap() {
		if (this.socketParam) {
			this.socket.send("Start");
		}
	}
	onDestroyMap() {
		if (this.socketParam) {
			this.socket.send("End");
		}
	}
	onSync(content: {xmin: number; ymin: number; xmax: number; ymax: number;} | {globalIds: any[]}, type: 'extent' | 'globalId') {
		if (this.socket) {
			this.socket.send(JSON.stringify({
				type: type,
				content: content
			}));
		}
	}
}
